// Generated from grammarParser.g4 by ANTLR 4.13.2
// jshint ignore: start
import antlr4 from "antlr4";
import grammarParserListener from "./grammarParserListener.js";
const serializedATN = [
  4, 1, 16, 51, 2, 0, 7, 0, 2, 1, 7, 1, 2, 2, 7, 2, 2, 3, 7, 3, 1, 0, 4, 0, 10,
  8, 0, 11, 0, 12, 0, 11, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 20, 8, 1, 1,
  2, 1, 2, 3, 2, 24, 8, 2, 1, 2, 1, 2, 3, 2, 28, 8, 2, 1, 2, 1, 2, 3, 2, 32, 8,
  2, 1, 2, 1, 2, 3, 2, 36, 8, 2, 1, 2, 1, 2, 3, 2, 40, 8, 2, 1, 2, 1, 2, 3, 2,
  44, 8, 2, 3, 2, 46, 8, 2, 1, 3, 1, 3, 1, 3, 1, 3, 0, 0, 4, 0, 2, 4, 6, 0, 0,
  59, 0, 9, 1, 0, 0, 0, 2, 15, 1, 0, 0, 0, 4, 45, 1, 0, 0, 0, 6, 47, 1, 0, 0, 0,
  8, 10, 3, 2, 1, 0, 9, 8, 1, 0, 0, 0, 10, 11, 1, 0, 0, 0, 11, 9, 1, 0, 0, 0,
  11, 12, 1, 0, 0, 0, 12, 13, 1, 0, 0, 0, 13, 14, 5, 0, 0, 1, 14, 1, 1, 0, 0, 0,
  15, 16, 5, 1, 0, 0, 16, 17, 5, 10, 0, 0, 17, 19, 3, 4, 2, 0, 18, 20, 5, 15, 0,
  0, 19, 18, 1, 0, 0, 0, 19, 20, 1, 0, 0, 0, 20, 3, 1, 0, 0, 0, 21, 23, 5, 2, 0,
  0, 22, 24, 3, 6, 3, 0, 23, 22, 1, 0, 0, 0, 23, 24, 1, 0, 0, 0, 24, 46, 1, 0,
  0, 0, 25, 27, 5, 11, 0, 0, 26, 28, 3, 6, 3, 0, 27, 26, 1, 0, 0, 0, 27, 28, 1,
  0, 0, 0, 28, 46, 1, 0, 0, 0, 29, 31, 5, 6, 0, 0, 30, 32, 3, 6, 3, 0, 31, 30,
  1, 0, 0, 0, 31, 32, 1, 0, 0, 0, 32, 46, 1, 0, 0, 0, 33, 35, 5, 3, 0, 0, 34,
  36, 3, 6, 3, 0, 35, 34, 1, 0, 0, 0, 35, 36, 1, 0, 0, 0, 36, 46, 1, 0, 0, 0,
  37, 39, 5, 4, 0, 0, 38, 40, 3, 6, 3, 0, 39, 38, 1, 0, 0, 0, 39, 40, 1, 0, 0,
  0, 40, 46, 1, 0, 0, 0, 41, 43, 5, 1, 0, 0, 42, 44, 3, 6, 3, 0, 43, 42, 1, 0,
  0, 0, 43, 44, 1, 0, 0, 0, 44, 46, 1, 0, 0, 0, 45, 21, 1, 0, 0, 0, 45, 25, 1,
  0, 0, 0, 45, 29, 1, 0, 0, 0, 45, 33, 1, 0, 0, 0, 45, 37, 1, 0, 0, 0, 45, 41,
  1, 0, 0, 0, 46, 5, 1, 0, 0, 0, 47, 48, 5, 12, 0, 0, 48, 49, 3, 4, 2, 0, 49, 7,
  1, 0, 0, 0, 9, 11, 19, 23, 27, 31, 35, 39, 43, 45,
];

const atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map(
  (ds, index) => new antlr4.dfa.DFA(ds, index)
);

const sharedContextCache = new antlr4.atn.PredictionContextCache();

export default class grammarParser extends antlr4.Parser {
  static grammarFileName = "grammarParser.g4";
  static literalNames = [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    "'''",
    "'_'",
    "'\\u2192'",
    "'\\u03BB'",
    "'|'",
    null,
    null,
    "'\\n'",
  ];
  static symbolicNames = [
    null,
    "WDCOMPLEX",
    "WDSYMDIG",
    "APOSUPPW",
    "UNIUPPW",
    "LOWW",
    "UPPW",
    "DIGITS",
    "APOSTROPHE",
    "UNDERSCORE",
    "ARROW",
    "LAMBDA",
    "PIPE",
    "SYMBOLS",
    "NUMUNI",
    "NEWLINE",
    "WS",
  ];
  static ruleNames = [
    "compilationUnit",
    "initialSetence",
    "setenses",
    "moreSetences",
  ];

  constructor(input) {
    super(input);
    this._interp = new antlr4.atn.ParserATNSimulator(
      this,
      atn,
      decisionsToDFA,
      sharedContextCache
    );
    this.ruleNames = grammarParser.ruleNames;
    this.literalNames = grammarParser.literalNames;
    this.symbolicNames = grammarParser.symbolicNames;
  }

  compilationUnit() {
    let localctx = new CompilationUnitContext(this, this._ctx, this.state);
    this.enterRule(localctx, 0, grammarParser.RULE_compilationUnit);
    var _la = 0;
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 9;
      this._errHandler.sync(this);
      _la = this._input.LA(1);
      do {
        this.state = 8;
        this.initialSetence();
        this.state = 11;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
      } while (_la === 1);
      this.state = 13;
      this.match(grammarParser.EOF);
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  initialSetence() {
    let localctx = new InitialSetenceContext(this, this._ctx, this.state);
    this.enterRule(localctx, 2, grammarParser.RULE_initialSetence);
    var _la = 0;
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 15;
      this.match(grammarParser.WDCOMPLEX);
      this.state = 16;
      this.match(grammarParser.ARROW);
      this.state = 17;
      this.setenses();
      this.state = 19;
      this._errHandler.sync(this);
      _la = this._input.LA(1);
      if (_la === 15) {
        this.state = 18;
        this.match(grammarParser.NEWLINE);
      }
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  setenses() {
    let localctx = new SetensesContext(this, this._ctx, this.state);
    this.enterRule(localctx, 4, grammarParser.RULE_setenses);
    var _la = 0;
    try {
      this.state = 45;
      this._errHandler.sync(this);
      switch (this._input.LA(1)) {
        case 2:
          this.enterOuterAlt(localctx, 1);
          this.state = 21;
          this.match(grammarParser.WDSYMDIG);
          this.state = 23;
          this._errHandler.sync(this);
          _la = this._input.LA(1);
          if (_la === 12) {
            this.state = 22;
            this.moreSetences();
          }

          break;
        case 11:
          this.enterOuterAlt(localctx, 2);
          this.state = 25;
          this.match(grammarParser.LAMBDA);
          this.state = 27;
          this._errHandler.sync(this);
          _la = this._input.LA(1);
          if (_la === 12) {
            this.state = 26;
            this.moreSetences();
          }

          break;
        case 6:
          this.enterOuterAlt(localctx, 3);
          this.state = 29;
          this.match(grammarParser.UPPW);
          this.state = 31;
          this._errHandler.sync(this);
          _la = this._input.LA(1);
          if (_la === 12) {
            this.state = 30;
            this.moreSetences();
          }

          break;
        case 3:
          this.enterOuterAlt(localctx, 4);
          this.state = 33;
          this.match(grammarParser.APOSUPPW);
          this.state = 35;
          this._errHandler.sync(this);
          _la = this._input.LA(1);
          if (_la === 12) {
            this.state = 34;
            this.moreSetences();
          }

          break;
        case 4:
          this.enterOuterAlt(localctx, 5);
          this.state = 37;
          this.match(grammarParser.UNIUPPW);
          this.state = 39;
          this._errHandler.sync(this);
          _la = this._input.LA(1);
          if (_la === 12) {
            this.state = 38;
            this.moreSetences();
          }

          break;
        case 1:
          this.enterOuterAlt(localctx, 6);
          this.state = 41;
          this.match(grammarParser.WDCOMPLEX);
          this.state = 43;
          this._errHandler.sync(this);
          _la = this._input.LA(1);
          if (_la === 12) {
            this.state = 42;
            this.moreSetences();
          }

          break;
        default:
          throw new antlr4.error.NoViableAltException(this);
      }
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  moreSetences() {
    let localctx = new MoreSetencesContext(this, this._ctx, this.state);
    this.enterRule(localctx, 6, grammarParser.RULE_moreSetences);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 47;
      this.match(grammarParser.PIPE);
      this.state = 48;
      this.setenses();
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }
}

grammarParser.EOF = antlr4.Token.EOF;
grammarParser.WDCOMPLEX = 1;
grammarParser.WDSYMDIG = 2;
grammarParser.APOSUPPW = 3;
grammarParser.UNIUPPW = 4;
grammarParser.LOWW = 5;
grammarParser.UPPW = 6;
grammarParser.DIGITS = 7;
grammarParser.APOSTROPHE = 8;
grammarParser.UNDERSCORE = 9;
grammarParser.ARROW = 10;
grammarParser.LAMBDA = 11;
grammarParser.PIPE = 12;
grammarParser.SYMBOLS = 13;
grammarParser.NUMUNI = 14;
grammarParser.NEWLINE = 15;
grammarParser.WS = 16;

grammarParser.RULE_compilationUnit = 0;
grammarParser.RULE_initialSetence = 1;
grammarParser.RULE_setenses = 2;
grammarParser.RULE_moreSetences = 3;

class CompilationUnitContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = grammarParser.RULE_compilationUnit;
  }

  EOF() {
    return this.getToken(grammarParser.EOF, 0);
  }

  initialSetence = function (i) {
    if (i === undefined) {
      i = null;
    }
    if (i === null) {
      return this.getTypedRuleContexts(InitialSetenceContext);
    } else {
      return this.getTypedRuleContext(InitialSetenceContext, i);
    }
  };

  enterRule(listener) {
    if (listener instanceof grammarParserListener) {
      listener.enterCompilationUnit(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof grammarParserListener) {
      listener.exitCompilationUnit(this);
    }
  }
}

class InitialSetenceContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = grammarParser.RULE_initialSetence;
  }

  WDCOMPLEX() {
    return this.getToken(grammarParser.WDCOMPLEX, 0);
  }

  ARROW() {
    return this.getToken(grammarParser.ARROW, 0);
  }

  setenses() {
    return this.getTypedRuleContext(SetensesContext, 0);
  }

  NEWLINE() {
    return this.getToken(grammarParser.NEWLINE, 0);
  }

  enterRule(listener) {
    if (listener instanceof grammarParserListener) {
      listener.enterInitialSetence(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof grammarParserListener) {
      listener.exitInitialSetence(this);
    }
  }
}

class SetensesContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = grammarParser.RULE_setenses;
  }

  WDSYMDIG() {
    return this.getToken(grammarParser.WDSYMDIG, 0);
  }

  moreSetences() {
    return this.getTypedRuleContext(MoreSetencesContext, 0);
  }

  LAMBDA() {
    return this.getToken(grammarParser.LAMBDA, 0);
  }

  UPPW() {
    return this.getToken(grammarParser.UPPW, 0);
  }

  APOSUPPW() {
    return this.getToken(grammarParser.APOSUPPW, 0);
  }

  UNIUPPW() {
    return this.getToken(grammarParser.UNIUPPW, 0);
  }

  WDCOMPLEX() {
    return this.getToken(grammarParser.WDCOMPLEX, 0);
  }

  enterRule(listener) {
    if (listener instanceof grammarParserListener) {
      listener.enterSetenses(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof grammarParserListener) {
      listener.exitSetenses(this);
    }
  }
}

class MoreSetencesContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = grammarParser.RULE_moreSetences;
  }

  PIPE() {
    return this.getToken(grammarParser.PIPE, 0);
  }

  setenses() {
    return this.getTypedRuleContext(SetensesContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof grammarParserListener) {
      listener.enterMoreSetences(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof grammarParserListener) {
      listener.exitMoreSetences(this);
    }
  }
}

grammarParser.CompilationUnitContext = CompilationUnitContext;
grammarParser.InitialSetenceContext = InitialSetenceContext;
grammarParser.SetensesContext = SetensesContext;
grammarParser.MoreSetencesContext = MoreSetencesContext;
